import { render, staticRenderFns } from "./TournamentResults.vue?vue&type=template&id=6fd1dc95&lang=pug"
import script from "./TournamentResults.vue?vue&type=script&lang=js"
export * from "./TournamentResults.vue?vue&type=script&lang=js"
import style0 from "./TournamentResults.vue?vue&type=style&index=0&id=6fd1dc95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports